import { useEffect } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { CssBaseline, ThemeProvider, createTheme } from "@mui/material";

import Quoter from "./components/Quoter";
import "./App.css";
// import { es } from "date-fns/locale";

const theme = createTheme({
  typography: {
    fontFamily: ['"Poppins"'].join(","),
  },
  palette: {
    secondary: {
      main: "#d5a459",
    },
    primary: {
      main: "#C29AD5"
    }
  },
});

function App() {
  const handleResize = () => {
    setTimeout(() => {
      let iframe = window?.parent?.document?.getElementById("iframe-quoter");
      if (iframe) {
        iframe.height = iframe.contentWindow.document.body.scrollHeight;
      }
    }, 100);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDateFns}>  {/* adapterLocale={es} */}
        <div className="App">
          <Quoter handleResize={handleResize} />
        </div>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
